package com.tfc.care.tfccare.ui

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.outlined.Download
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.tfc.care.tfccare.downloadImageFromUrl
import io.kamel.image.KamelImage
import io.kamel.image.asyncPainterResource
import kotlinx.coroutines.launch
import kotlin.random.Random

@Composable
fun ImageScreen(url: String?, onBack: () -> Unit) {

    val scope = rememberCoroutineScope()
    Column(Modifier.fillMaxSize(), horizontalAlignment = Alignment.CenterHorizontally) {
        Row(
            Modifier.fillMaxWidth().height(80.dp).clickable { onBack() },
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                imageVector = Icons.AutoMirrored.Default.ArrowBack,
                contentDescription = "Back",
            )
            Text(text = "Back", fontSize = 20.sp, modifier = Modifier.padding(horizontal = 16.dp))

            Spacer(modifier = Modifier.weight(1f))

            Text(text = "Download", fontSize = 20.sp, modifier = Modifier.padding(horizontal = 16.dp))
            Icon(
                imageVector = Icons.Outlined.Download,
                contentDescription = "Download",
                modifier = Modifier.padding(end = 16.dp).size(40.dp).clickable {
                    val fileName = "${Random(1000)}.jpg"
                    scope.launch {
                        downloadImageFromUrl(
                            imageUrl = url?:"",
                            fileName = fileName
                        )
                    }
                }
            )
        }
        url?.let {
            KamelImage(
                resource = asyncPainterResource(it),
                contentDescription = "Chat image",
                modifier = Modifier.fillMaxWidth().weight(1f),
                contentScale = ContentScale.Fit,
                onLoading = {
                    Box(
                        modifier = Modifier.fillMaxSize(),
                        contentAlignment = Alignment.Center
                    ) {
                        CircularProgressIndicator()
                    }
                },
                onFailure = { exception ->
                    Box(
                        modifier = Modifier.fillMaxSize(),
                        contentAlignment = Alignment.Center
                    ) {
                        Text("Failed to load image: ${exception.message}")
                    }
                }
            )
        } ?: Text(text = "Image not found")
    }
}